const SHORT_DATE_FORMATTER: Intl.DateTimeFormat = new Intl.DateTimeFormat('nl-NL', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

export function formatShortDate(isoDate: string): string {
  const date: Date = new Date(isoDate);
  if (isNaN(date.getTime())) return '';
  return SHORT_DATE_FORMATTER.format(date).replace(/\./g, '');
}
